import React from "react";
import AllDataContact from "../../../Form/AllDataContact";
import caseFullFormStyle from "./caseFullFormStyle";
import SubForm from "./SubForm";
import _ from "lodash";
import { translate } from "../../../../services/Translations/translatorService";
import { getFullFormDefinition } from "../../../../services/Product/ProductService/productService";
import ContentBox from "../../../ContentBox/ContentBox";
import { FullFormDefinition } from "../../../../types/FormDefinitions/FullFormDefinition";
import { useCurrentUser } from "../../../../provider/CurrentUserProvider";
import { ProductUnion } from "../../../../types/ProductUnion";
import { Box, useTheme } from "@mui/material";

type CaseFullFormProps = {
  product: ProductUnion;
  contactHeadline?: string;
  formDisabled?: boolean;
  refreshPage: Function;
};
const CaseFullForm = ({
  product,
  contactHeadline = "Kontaktdaten",
  formDisabled = false,
  refreshPage,
}: CaseFullFormProps) => {
  const currentUser = useCurrentUser();
  const formDefinition: FullFormDefinition = getFullFormDefinition(product, currentUser);

  return (
    <>
      <Box sx={caseFullFormStyle.scrollToAnchor} id={"contact"} />
      <ContentBox headline={contactHeadline} headlineVariant="h2">
        <AllDataContact formDisabled={formDisabled} />
      </ContentBox>
      {_.map(formDefinition, (currentFormDefinition, key) => {
        return (
          <React.Fragment key={key}>
            <Box sx={caseFullFormStyle.scrollToAnchor} id={key} />
            <SubForm
              headline={translate("allDataForm." + key)}
              formDefinition={currentFormDefinition}
              product={product}
              formDisabled={formDisabled}
              refreshPage={refreshPage}
            />
          </React.Fragment>
        );
      })}
    </>
  );
};

export default CaseFullForm;
